import { render } from "./MatricFrame.vue?vue&type=template&id=5dee9fbd&scoped=true"
import script from "./MatricFrame.vue?vue&type=script&lang=js"
export * from "./MatricFrame.vue?vue&type=script&lang=js"

import "./MatricFrame.vue?vue&type=style&index=0&id=5dee9fbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dee9fbd"]])

export default __exports__